import './App.css';
import GlobeComponent from './Globe';
import Header from './Header';
import Sections from './Sections';

function App() {
  return (
    <div className="App">
      <Header />
      <GlobeComponent />
      <Sections />
    </div>
  );
}

export default App;
